// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { PrereleaseEmailSignup } = initSchema(schema);

export {
  PrereleaseEmailSignup
};